import { PlanType } from '~/utils/payment';
import { createPaymentApi } from '~/api';
import { apiResponseHandler, ApiResponseEnum } from '~/utils/api';

/**
 * Payment service for Dodo payment integration
 */

interface PaymentResponse {
  payment_url: string;
}

/**
 * Initiate payment with Dodo payment system using the existing API pattern
 */
export const initiatePayment = async (plan: PlanType): Promise<PaymentResponse> => {
  try {
    const response = await apiResponseHandler<PaymentResponse>(
      createPaymentApi({ plan })
    );

    if (response.type === ApiResponseEnum.Success) {
      if (!response.data.payment_url) {
        throw new Error('Invalid response: missing payment_url');
      }
      return response.data;
    } else {
      // Handle API failure
      const errorMessage = response.error || 'Payment initiation failed';
      console.error('Payment API error:', errorMessage);
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('Payment initiation error:', error);
    
    if (error instanceof Error) {
      throw error;
    }
    
    throw new Error('Failed to initiate payment. Please try again.');
  }
};

/**
 * Redirect to payment URL
 */
export const redirectToPayment = (paymentUrl: string): void => {
  window.location.href = paymentUrl;
};

/**
 * Complete payment flow - initiate and redirect
 */
export const processPayment = async (plan: PlanType): Promise<void> => {
  const paymentData = await initiatePayment(plan);
  redirectToPayment(paymentData.payment_url);
};
